var walletWhite = require("./wallet_white.svg");
var walletBlue = require("./wallet_blue.svg");
var walletBlueBadge = require("./wallet_blue_badge.svg");
export { walletWhite, walletBlue, walletBlueBadge };
